export { InvestorFormComponent } from './investor-form.component';



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/investor/investor-form/index.ts